import { z } from 'zod';

/**
 * Confirmarea participarii unui profesor care revine, in editia noua.
 *
 * Un singur camp editabil: acordul cu regulamentul (checkbox). Decizia „particip / nu particip"
 * NU e camp de formular — sunt doua butoane, iar hook-ul o trimite el (wantsToRegisterSchool).
 * Inainte erau doua tri-state-uri (null/true/false) care cereau patru tap-uri si un dialog.
 */
export const schoolRegistrationConfirmationSchema = z.object({
  // `.refine` (nu `z.literal(true)`) ca sa pastreze tipul de INPUT `boolean`, nu literalul `true`
  // — altfel `Resolver<{ amCititSiSuntDeAcord: true }, ...>` nu se potriveste cu
  // `SchoolRegistrationConfirmationFormInput` (`{ amCititSiSuntDeAcord: boolean }`), pe care
  // Checkbox-ul chiar il produce (TS2322).
  amCititSiSuntDeAcord: z.boolean().refine((val) => val === true, {
    message: 'Confirmarea participării cere acordul cu Regulamentul și Nota de informare.',
  }),
});

export type SchoolRegistrationConfirmationFormData = z.output<typeof schoolRegistrationConfirmationSchema>;
export type SchoolRegistrationConfirmationFormInput = { amCititSiSuntDeAcord: boolean };
